import * as React from 'react';
import { Row, Button, Alert } from 'react-bootstrap';
import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, map, isEmpty, get } from 'lodash';
import { connect } from 'react-redux';
import ResetPasswordForm from './components/ResetPasswordForm';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { Link } from 'react-router-dom';
import {IStore} from '../../../../redux/IStore';
import Helmet from 'react-helmet';

interface IResetPasswordProps {
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  auth: any;
}

interface IResetPasswordState {
  hasPasswordBeenReset: boolean;
}

class ResetPassword extends React.Component<IResetPasswordProps, IResetPasswordState> {
  private closeError = () => {
    const { actions } = this.props;

    actions.auth.reset();
  }

  private renderErrors = (errors) => {
    return (
      <Alert onDismiss={this.closeError}>
        {map(errors, (error, key) => {
          return (
            <p key={key}>{error.detail}</p>
          );
        })}
      </Alert>
    );
  }

  private handleSubmit = (values) => {
    const { actions, match } = this.props;
    const token = match.params.token;
    actions.auth.resetPassword(token, values);
  }

  public render() {
    const { auth } = this.props;
    const errors = get(auth, 'errors.resetPassword.errors');
    const hasResetPwdError = auth.errors.resetPassword.hasError;

    return (
      <Row className="page-container">
        <Helmet>
          <title>Reset Password</title>
        </Helmet>
        <div className="customer-section-title">
          <div className="title">
            <h1>Create password</h1>
            <div className="title--subtitle">
              <p>Please enter a password below for your online account.</p>
              {(! isEmpty(errors)) && (
                <div>
                  {this.renderErrors(errors)}
                </div>
              )}
            </div>
          </div>
          {!auth.hasPasswordBeenReset ? (
            <ResetPasswordForm onSubmit={this.handleSubmit} />
          ) : (
            <div className="log-in">
              <p>Your password has been reset, please login to access your account.</p>
              <Link to="/auth/login">
                <Button bsStyle="primary" bsSize="large">
                  Log In
                </Button>
              </Link>
            </div>
          )}
        </div>
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('reset_password');

    return component;
  },
  connect(
    (state: IStore) => ({
      auth: state.auth,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ResetPassword);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ResetPassword/index.tsx